// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['admin']


const riscosBreadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Tipo de Riscos',
    to: 'TipoRiscos'
  }
]

export default [
{
  path: '/risco-pais',
  name: 'TipoRiscos',
  component: () => import('@/views/RiscoPais/RiscoPaisListPage.vue'),
  meta: {
    roles: ROLES,
    title: 'Tipo de Riscos',
    breadcrumb: riscosBreadCrumb
  },
},
{
  path: '/risco-pais/novo',
  name: 'RiscoNovo',
  component: () => import('@/views/RiscoPais/NovoRiscoPaisPage.vue'),
  meta: {
    roles: ROLES,
    title: 'Novo Risco',
    breadcrumb: [
      ...riscosBreadCrumb,
      {
          label: 'Novo Risco',
          to: 'RiscoNovo'
      }
    ]
  }
},
{
  path: '/risco-pais/:id/edit',
  name: 'RiscoEdit',
  component: () => import('@/views/RiscoPais/NovoRiscoPaisPage.vue'),
  meta: {
    roles: ROLES,
    title: 'Detalhes do Risco',
    breadcrumb: [
      ...riscosBreadCrumb,
      {
        label: 'Novo Risco',
        to: 'RiscoEdit'
      }
    ]
  }
}
];